import {Cureus} from '../Cureus';

Cureus.AboutPublishingCarousel = {};

//= require_tree ./AboutPublishingCarousel